import i18next from 'i18next';

i18next.addResources('es', 'projectPopup', {
  close: 'Cerrar'
});

i18next.addResources('en', 'projectPopup', {
  close: 'Close'
});

i18next.addResources('pt', 'projectPopup', {
  close: 'Fechar'
});
